/** One plain line for the load failure card, so a screenshot tells which step stopped.
 * Only Korean messages written for people are shown as-is; addresses are stripped and
 * library text is reduced to its error name. */
const HANGUL=/[가-힣]/;
const clean=(text:string)=>text.replace(/https?:\/\/\S+/g,'').replace(/\s+/g,' ').trim().slice(0,160);
export const EDITOR_CONNECT_TIMEOUT_REASON='편집 화면이 작업 화면과 15초 안에 연결되지 않았습니다.';
export function editorLoadFailureReason(error:unknown):string{
  if(!(error instanceof Error))return '알 수 없는 문제로 멈췄습니다.';
  const head=HANGUL.test(error.message)?clean(error.message):`알 수 없는 문제로 멈췄습니다(${error.name}).`;
  const cause=error.cause instanceof Error?error.cause:undefined;
  if(!cause)return head;
  return `${head} — ${HANGUL.test(cause.message)?clean(cause.message):`세부 오류 ${cause.name}`}`;
}
